import { Component, OnInit, AfterViewChecked } from '@angular/core';

import { Location } from '../../shared/models/location.model';
import { LocationService } from '../../shared/services/location.service';
import { SessionService } from '../../shared/services/session.service';
import { ModalService } from '../../shared/modals/modal.service';
import { Log } from '../../shared/utils/log';
import { RegionalLocations } from '../../shared/models/regional-locations.model';
import { SpinnerService } from '../../shared/spinner/spinner.service';
import { LocationFilterEvent } from '../../shared/models/location-filter-event.model';
import { Utils } from '../../shared/utils/utils';
import { TranslateService } from '@ngx-translate/core';
import { CBSAService } from 'src/app/shared/services/cbsa.service';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

declare var $: any;

@Component({
    templateUrl: 'select-location.component.html',
    standalone: false
})
export class SelectLocationComponent implements OnInit, AfterViewChecked {

    public hasAccessCodeLocation: boolean = false;
    public _accessCodeLocations: Array<Array<Location>>;
    public selectedLocation: Location;
    public _usLocations: Array<Array<Location>>;
    public _caLocations: Array<Array<Location>>;
    public _otherLocations: Array<Array<Array<Location>>>;
    public yourLocations: Array<Array<Location>>;
    public _regionalLocations: Array<RegionalLocations>;
    public view: string;
    public accessCode: string = '';
    private serviceName: string;

    constructor(private locationService: LocationService,
                private spinnerService: SpinnerService,
                private sessionService: SessionService,
                private modalService: ModalService,
                private translate: TranslateService,
                private cbsaService: CBSAService) {
        this.view = 'alpha';
    }

    ngOnInit() {
        // The component onInit was being called before the parent onInit was finalized, so
        // check for the sessionInitialized or subscribe to sessionService
        if (this.sessionService.isSessionInitialized) {
            this.doInit();
            Utils.scrollUp();
        } else {
            this.sessionService.sessionInitialized.subscribe((res: boolean) => {
                if (res) {
                    this.doInit();
                    this.sessionService.sessionInitialized.unsubscribe();
                }
            });
            Utils.scrollUp();
        }
    }

    ngAfterViewChecked() {
        // jQuery for toggling the arrow image.
        $('.collapse').on('show.bs.collapse', function() {
            $(this).parent().find('#collapse-arrow').removeClass('fa-chevron-right').addClass('fa-chevron-down');
        })
        .on('hide.bs.collapse', function() {
            $(this).parent().find('#collapse-arrow').removeClass('fa-chevron-down').addClass('fa-chevron-right');
        });
        // jQuery for autofocus in the access code modal
        $('#accessCodeModal').on('shown.bs.modal', function() {
            $('#txtAccessCode').focus();
        });
        $('#helpModal').on('shown.bs.modal', function() {
            $('#closeModal').focus();
        });
    }

    public submitAccessCode() {
        this.spinnerService.show();
        this.locationService.getAllLocations(null, null, true, true, this.serviceName, this.accessCode)
            .subscribe(
                res => {
                    if (res !== null) {
                        let accessLocations = new Array<Array<Location>>();
                        accessLocations.push(res);
                        this._accessCodeLocations = accessLocations;
                        this.hasAccessCodeLocation = true;
                        this.accessCode = '';
                        this.spinnerService.hide();
                        // hide the modal
                        $('#accessCodeModal').modal('hide');

                    } else {
                        this.spinnerService.hide();
                        Log.warning('No locations returned for access code: ' + ' ' + this.accessCode);
                        this.hasAccessCodeLocation = false;
                        $('#accessCodeModal').modal('hide');
                        this.translate.get('SCHEDULE_INTERVIEW.LOCATION.ACCESS_CODE_NO_LOCATIONS').subscribe((res: string) => {
                            let message = res + this.accessCode;
                            this.modalService.warn(message).then(() => {
                                $('#accessCodeModal').modal('show');
                            });
                            this.spinnerService.hide();
                        });
                    }
                    this.accessCode = '';
                },
                error => {
                    this.spinnerService.hide();
                    this.accessCode = '';
                    Log.error('An error occured while retrieving locations for access code.', error);
                    this.modalService.warn('SCHEDULE_INTERVIEW.LOCATION.ACCESS_CODE_ERROR');
                }
            );
    }

    public filterLocations(event: LocationFilterEvent) {
        this._usLocations = this._caLocations = this._otherLocations = this._regionalLocations = null;
        if (event.reset) {
            this.getAllLocations();
        } else {
            this.getFilteredLocations(event);
        }
    }

    public onLocationSelected(location: Location) {
        this.selectedLocation = location;
        this.sessionService.location = location;
    }

    private doInit() {
        this.getAllLocations();

        if (this.sessionService.location) {
            this.selectedLocation = this.sessionService.location;
            this.serviceName = this.sessionService.service;
        }
    }

    private getAllLocations() {
        this.spinnerService.show();
        let temporary: boolean = null;
        if (this.sessionService.viewOnly) {
            temporary = false;
        }

        this.locationService.getAllLocations(null, temporary, false, true, this.sessionService.service)
            .subscribe(
                res => {
                    if (res !== null) {
                        this._usLocations = this.locationService.getUSLocations();
                        this._caLocations = this.locationService.getCALocations();
                        this._otherLocations = this.locationService.getOtherCountryLocations();
                        this._regionalLocations = this.locationService.getUsLocationsByRegion();
                        this.spinnerService.hide();
                    } else {
                        this._usLocations = this._caLocations = this._otherLocations = this._regionalLocations = null;
                        this.spinnerService.hide();
                    }
                },
                error => {
                    this.spinnerService.hide();
                    Log.error('Error retrieving locations', error);
                    this.modalService.warn('SCHEDULE_INTERVIEW.LOCATION.SERVICE_ERROR');
                }
            );
    }

    private getFilteredLocations(filter: LocationFilterEvent) {
        this.spinnerService.show();
        this.locationService.getFilteredLocations(filter)
            .subscribe(
                res => {
                    if (res !== null) {
                        this._usLocations = this.locationService.getUSLocations();
                        this._caLocations = this.locationService.getCALocations();
                        this._otherLocations = this.locationService.getOtherCountryLocations();
                        this._regionalLocations = this.locationService.getUsLocationsByRegion();
                        this.spinnerService.hide();
                    } else {
                        this._usLocations = this._caLocations = this._otherLocations = this._regionalLocations = null;
                        this.spinnerService.hide();
                    }
                },
                error => {
                    this.spinnerService.hide();
                    Log.error('Error retieving filtered locaitons', error);
                    this.modalService.warn('SCHEDULE_INTERVIEW.LOCATION.SERVICE_ERROR').then(res => {
                        this.getAllLocations();
                    });
                }
            );
    }

    // tslint:disable-next-line:member-ordering
    public isCBSAEligible() : boolean {
        if (!this.sessionService.viewOnly && this.sessionService.returnUrl && this.sessionService.returnUrl.indexOf(environment.returnUrls['ttp-external']) >-1 &&
            (this.serviceName === 'NEXUS')) {
            return true;
        } else {
            return false;
        }
    }

    // tslint:disable-next-line:member-ordering
    public onOtherCALocationsSelected() {
        // Get CBSA redirect URL
        this.modalService.confirm('SCHEDULE_INTERVIEW.LOCATION.CONTINUE_TO_CBSA_WARNING', 'MODAL.LEAVING_SITE_WARNING', 'GENERAL_REUSABLE.BUTTON_LABEL.CANCEL', 'GENERAL_REUSABLE.CONTINUE')
        .then(res => {
            if (res) {
              this.spinnerService.show();

              this.cbsaService.getRedirectURL(this.sessionService.appointment.applicationCode).subscribe(urlRes => {

                this.spinnerService.hide();
                Utils.gotoExternalUrl(urlRes);

              },
              err =>  {
                this.spinnerService.hide();
                Utils.scrollUp();
                this.modalService.alert('SCHEDULE_INTERVIEW.LOCATION.CBSA_GENERIC_ERROR');
              });
            }
        });
    }
}
